export interface CreateSessionResponse {
    sessionId: string;
    /** Expiration time in minutes */
    expirationTime: number;
    "X-Session-Key": string;
    "X-Session-Token": string;
}
